export const ROUTE_ACCESS_POLICIES = {
  HOME_ONLY: 'home-only',
  STANDARD: 'standard',
};
